import React from 'react';
import './PC.css';
import Gosebrink from '../../img/PC/Gosebrink.png'
import Hladky from '../../img/PC/Hladky.png'
import Kaufman from '../../img/PC/Kaufman.png'
import Radzio from '../../img/PC/Radzio.png'
import Ruffieux from '../../img/PC/Ruffieux.png'
import Salnikov from '../../img/PC/Salnikov.png'
import Shechter from '../../img/PC/Shechter.png'
import Yadav from '../../img/PC/Yadav.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pc: [
        {
          photo: Ruffieux,
          name: 'Michel Ruffieux',
          position: 'Senior software engineer',
          ln: 'https://www.linkedin.com/in/mruffieux/',
          tw: 'https://twitter.com/codepawn',
          github: 'https://github.com/mruffieux',
        },
        {
          photo: Shechter,
          name: 'Elad Shechter',
          position: 'CSS/HTML Architect',
          tw: 'https://twitter.com/eladsc',
        },
        {
          photo: Kaufman,
          name: 'Nir Kaufman',
          position: 'Front End Tech Lead',
          ln: 'https://www.linkedin.com/in/nirkaufman/',
          website: 'https://nir.life/',
        },
        {
          photo: Radzio,
          name: 'Greg Radzio',
          position: 'CTO',
          ln: 'https://www.linkedin.com/in/greg-radzio-58aa046b/',
          tw: 'https://twitter.com/gregradzio',
          github: 'https://github.com/gradzio',
          website: 'https://medium.com/@gregradzio',
          youtube: 'https://www.youtube.com/c/GregRadzio ',
        },
        {
          photo: Salnikov,
          name: 'Maxim Salnikov',
          position: 'Developer Engagement Lead',
          ln: 'https://www.linkedin.com/in/webmax/',
          tw: 'https://twitter.com/webmaxru',
        },
        {
          photo: Hladky,
          name: 'Michael Hladky',
          position: 'CEO of Hladky IT consulting GmbH and Push-Based',
          ln: 'https://www.linkedin.com/in/michael-hladky-519340148/',
          tw: 'https://twitter.com/Michael_Hladky',
          github: 'https://github.com/BioPhoton?tab=overview&from=2021-08-01&to=2021-08-25',
        },
        {
          photo: Gosebrink,
          name: 'Fabian Gosebrink',
          position: 'Technical Lead',
          tw: 'https://twitter.com/fabiangosebrink',
        },
        {
          photo: Yadav,
          name: 'Santosh Yadav',
          position: 'Software Consultant',
          ln: 'https://www.linkedin.com/in/santoshyadavdev/',
          tw: 'https://twitter.com/SantoshYadavDev',
          github: 'https://github.com/santoshyadavdev',
          website: 'https://stars.github.com/profiles/santoshyadavdev/',
        },
      ]
    }
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className="pc_img_block">
          <img className="team_img" src={item.photo} alt={item.name} />
        </div>
        <div className="pc_info">
          <p className="pc_name">{item.name}</p>
          <p className="pc_position">{item.position}</p>
          <div className="pc_links">
            {item.fb && <a className="pc_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="pc_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="pc_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="pc_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="pc_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="pc_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
      return (
          <div className="pc" id='pc'>
              <h3>Program committee</h3>
              <div className='container team_wrap'>
                  <div className="pc_block">
                    {this.state.pc.map((item, i) => this.renderPC(item, i))}
                  </div>
              </div>
          </div>
      )
  }
}